import axios from '@/libs/api.request'
const stock = {
  // 出货剩货
  getStock: (data) => {
    return axios.post({
      url: '/Stock',
      data: data
    })
  },
  // 出货剩货明细
  getStockDetail: (data) => {
    return axios.post({
      url: '/Stock/stockDetail',
      data: data
    })
  },
  // 产品出入库明细
  getProductDetail: (data) => {
    return axios.post({
      url: '/Stock/ProductDetail',
      data: data
    })
  },
  // 产品出入库明细(按门店、分类汇总)
  getProductTypeDetail: (data) => {
    return axios.post({
      url: '/Stock/ProductTypeDetail',
      data: data
    })
  },
  // 时间段库存
  getRealTimeStock: (data) => {
    return axios.post({
      url: '/Stock/RealTime',
      data: data
      // + axios.parseParams(data)
    })
  },
  // 各门店库存
  getStockDept: (data) => {
    return axios.get({
      url: '/Stock/Dept?' + axios.parseParams(data)
    })
  },
  // 单品月明细
  getStockMonthLy: (data) => {
    return axios.post({
      url: '/Stock/MonthLy',
      data: data
    })
  },
  // 分类汇总
  getStockSubtotal: (data) => {
    return axios.post({
      url: '/Stock/Subtotal',
      data: data
    })
  },
  // 分类月明细
  getStockTypeMonthLy: (data) => {
    return axios.post({
      url: '/Stock/TypeMonthLy',
      data: data
    })
  },
  // 时间段库存
  getStockProductRealTime: (data) => {
    return axios.post({
      url: '/Stock/ProductRealTime',
      data: data
    })
  },
  // 报货分类汇总
  getStockRequestSum: (data) => {
    return axios.post({
      url: '/Stock/RequestSum',
      data: data
    })
  },
  // 报货列表
  getStockProductTypeRequestDetail: (data) => {
    return axios.post({
      url: '/Stock/ProductTypeRequestDetail',
      data: data
    })
  }
}
export default stock



// WEBPACK FOOTER //
// ./src/api/api-stock.js